<template>
    <form @submit.prevent="handleSubmit()">
        <div id="payment-element">
        </div>
        <span class="error">

        </span>
        <button type="submit" id="submit" class="action" :disabled="loadingPayment">
            <span v-if="!loadingPayment">Make payment</span>
            <div class="loader" v-if="loadingPayment"></div>            
        </button>
        <div class="info">
            Payments are securely handled with Stripe. 
            doored never stores or accesses your payment details.
        </div>
    </form>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import axios from 'axios';
import { RegisterRedirects, AccountPermissionType } from '@/store/state';

const loadingPayment = ref<boolean>(false);
const errorMsg = ref<string>();
const stripe = Stripe(`${import.meta.env.VITE_STRIPE_KEY}`);

let elements: any;
const emit = defineEmits<{
    (e: 'triedWithFree') : void
}>();
const props = defineProps<{
    promo_applied: boolean
}>();

async function initialize() {
    const cached_email = await localStorage.getItem('email')
    const cached_permission = await localStorage.getItem('permission')
    const account_type = await localStorage.getItem('account_type')
    const is_graduating = await localStorage.getItem('is_graduating')
    let pack = await JSON.parse(localStorage.getItem('cached_pack') as string)
    if (!pack) {
        pack = []
    }

    let promo: string|null = null;
    if (props.promo_applied) {
        promo = await localStorage.getItem('promo_code')
    } else [
        promo = ''
    ]

    const response = await axios.post(
        `${import.meta.env.VITE_API_BASE}/payments/create-fake-payment`, 
        {user_email: cached_email, permission: cached_permission, items: pack, account_type: account_type, promo_code: promo, is_graduating: is_graduating},
        {withCredentials: true}
    )
    const { clientSecret } = response.data;
    const appearance = {theme: 'stripe'}
    elements = stripe.elements({appearance, clientSecret})
    const paymentElementOptions = {layout: 'tabs'}
    const paymentElement = elements.create("payment", paymentElementOptions)
    paymentElement.mount("#payment-element")
}

async function handleSubmit() {
    loadingPayment.value = true;
    const cached_permission = localStorage.getItem('permission')
    if (cached_permission === AccountPermissionType.FREE) {
        emit('triedWithFree')
        return;
    }

    const { error } = await stripe.confirmPayment({
        elements,
        confirmParams: {
            return_url: `${import.meta.env.VITE_SPA_BASE}/signup?redirect=${RegisterRedirects.PayAttempted}`,
        },
    });

    if (error.type === 'card_error' || error.type === 'validation_error') {
        errorMsg.value = error.message;
        loadingPayment.value = false;
    }
}

onMounted(async () => {
    if (!window.matchMedia("(max-width: 1024px)").matches) {
        initialize();
    }
})

</script>

<style scoped>
form {
    z-index: 100;
    background-color: #fff;
    border: 1.5px solid #e6e6e6;
    border-radius: 8px;    
    box-shadow: 0 0 0 1px rgba(0,0,0,0.08), 0px 2px 2px rgba(0,0,0,0.04);
    padding: 24px;
}
#submit {
    margin-top: 12px;
}
.action {
    text-align: center;
    border-radius: 6px;
    box-shadow: 1px 1px 8px rgba(0, 0, 0, 0.07);
    transition: 160ms cubic-bezier(0.25,0.46,0.45,0.94);
    transition-property: background-color;
    font-family: "Inter";
    font-size: 15px;
    letter-spacing: -0.013em;
    font-weight: 510;
    font-variation-settings: "opsz" 28;
    cursor: pointer;
    width: 100%;
    height: 48px;
    background-color: #000000;
    color: hsla(0, 0%, 93%, 1);
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    text-align: center;
    border: none;
}
.info {
    margin-top: 12px;
    position: relative;
    margin-left: auto;
    margin-right: auto;
    width: fit-content;
    height: auto;
    text-align: center;
    font-family: "Inter";
    font-size: 15px;
    letter-spacing: -0.013em;
    font-weight: 510;
    font-variation-settings: "opsz" 28;
    color: #666666; /*#414552*/
    z-index: 10;
    animation: .8s ease 1 normal both running kiki;
    animation-delay: .8s;
    transform: translateX(6px);
}
.info svg {
    fill: #666666;
}
.loader {
        width: 1.15rem;
        height: 1.15rem;
        border-radius: 50%;
        position: relative;
        animation: rotate 1s linear infinite
      }
      .loader::before , .loader::after {
        content: "";
        box-sizing: border-box;
        position: absolute;
        inset: 0px;
        border-radius: 50%;
        border: 2px solid #FFF;
        animation: prixClipFix 2s linear infinite ;
      }
      .loader::after{
        border-color: transparent;
        animation: prixClipFix 2s linear infinite , rotate 0.5s linear infinite reverse;
        inset: 6px;
      }

      @keyframes rotate {
        0%   {transform: rotate(0deg)}
        100%   {transform: rotate(360deg)}
      }

      @keyframes prixClipFix {
          0%   {clip-path:polygon(50% 50%,0 0,0 0,0 0,0 0,0 0)}
          25%  {clip-path:polygon(50% 50%,0 0,100% 0,100% 0,100% 0,100% 0)}
          50%  {clip-path:polygon(50% 50%,0 0,100% 0,100% 100%,100% 100%,100% 100%)}
          75%  {clip-path:polygon(50% 50%,0 0,100% 0,100% 100%,0 100%,0 100%)}
          100% {clip-path:polygon(50% 50%,0 0,100% 0,100% 100%,0 100%,0 0)}
      }
</style>